var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isDisplay && _vm.showRule !== "render"
    ? _c(
        "preview-form-item",
        {
          attrs: {
            labelText: _vm.labelName,
            labelWidth: _vm.labelWidth,
            labelPosition: _vm.labelPosition,
            textAlign: _vm.labelTextPosition,
            formType: _vm.formType,
            paddingLeft: _vm.paddingLeft
          }
        },
        [
          _c(
            "div",
            { staticClass: "form-item_input" },
            [
              _c("el-switch", {
                style: { width: _vm.width },
                attrs: { disabled: _vm.isDisabled },
                model: {
                  value: _vm.currentModel,
                  callback: function($$v) {
                    _vm.currentModel = $$v
                  },
                  expression: "currentModel"
                }
              })
            ],
            1
          )
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9ca4dd4c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9ca4dd4c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/preview_item/PreviewItemSwitch.vue
// module id = null
// module chunks = 